import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=658d49c5&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"
import style0 from "./Modal.vue?vue&type=style&index=0&id=658d49c5&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('658d49c5')) {
      api.createRecord('658d49c5', component.options)
    } else {
      api.reload('658d49c5', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=658d49c5&", function () {
      api.rerender('658d49c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/Modal.vue"
export default component.exports